import React, { Component } from 'react'
import { NavLink, useLocation } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSignInAlt } from '@fortawesome/free-solid-svg-icons'
import SmartWatch from '../assets/smartwatchblue.png'
import SmartWatchWhite from '../assets/smartwatchwhite.png'

import psIcon from '../assets/ps-icon.png'
import psLogo from '../assets/added-logo.png'

class Sidebar extends Component {
  constructor(props) {
    super(props)

    this.state = {
      isNewWindow: false,
      secondWindow: null,
      isDevicesClicked: false,
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.location.pathname !== this.props.location.pathname) {
      this.setState({ isDevicesClicked: false })
    }
  }

  render() {
    const { isCollapsed, location, user } = this.props
    const loggedIn = user.id
    const hide = { display: 'none' }
    const show = { display: 'block' }

    const isDevicesActive =
      location.pathname === '/devices' || this.state.isDevicesClicked
    const smartwatchIcon = isDevicesActive ? SmartWatchWhite : SmartWatch

    // Define a style for each NavLink:
    // - Use flex to center content vertically.
    // - Add top and bottom padding.
    // Note: We do not include a "color" property here so that CSS rules (or bootstrap classes)
    // control the text/icon color (blue by default, white when active).
    const navLinkStyle = {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      padding: '10px 0', // 10px top and bottom padding
      textDecoration: 'none',
      marginBottom: '5px',
      marginTop: '5px'
    }

    // Define a style for the icons to provide additional spacing between the icon and text.
    const iconStyle = {
      marginBottom: '10px',
      fontSize: '1.5rem',
    }

    return (
      <div
        className={`nav flex-md-column nav-pills app-sidebar ${isCollapsed ? 'sidebar-collapsed' : 'sidebar-expanded'}`}
        aria-orientation='vertical'
      >
        <div className='app-sidebar-logo-row'>
          <a href='https://www.marketing.patientsafetyinc.com/'>
            <img
              className='app-sidebar-primary-logo'
              src={psIcon}
              width='38'
              height='38'
              alt='PatientSafetyLogo'
            />
          </a>
          <a href='https://www.marketing.patientsafetyinc.com/'>
            <img
              className={`app-sidebar-secondary-logo ${isCollapsed ? 'is-hidden' : ''}`}
              src={psLogo}
              width='73.35'
              height='38'
              alt='PatientSafetyLogo'
            />
          </a>
        </div>

        {/* Patients Link */}
        <NavLink
          className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}
          to='/patients'
          
          style={loggedIn ? { ...show, ...navLinkStyle } : hide}
        >
          <i className='fad fa-bed' style={iconStyle}></i>
          <span className={`app-sidebar-label ${isCollapsed ? 'is-hidden' : ''}`}>Patients</span>
        </NavLink>

        {/* Reports Link */}
        <NavLink
          className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}
          to='/reports'
          
          style={loggedIn ? { ...show, ...navLinkStyle } : hide}
        >
          <i className='far fa-file-chart-line' style={iconStyle}></i>
          <span className={`app-sidebar-label ${isCollapsed ? 'is-hidden' : ''}`}>Reports</span>
        </NavLink>

        {/* Login Link */}
        <NavLink
          className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}
          to='/login'
          
          style={loggedIn ? hide : { ...show, ...navLinkStyle }}
        >
          <FontAwesomeIcon style={iconStyle} icon={faSignInAlt} />
          <span className={`app-sidebar-label ${isCollapsed ? 'is-hidden' : ''}`}>Login</span>
        </NavLink>

        {/* Devices Link */}
        <NavLink
          className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}
          to='/devices'
          
          style={loggedIn ? { ...show, ...navLinkStyle } : hide}
          onMouseUp={() => this.setState({ isDevicesClicked: true })}
          >
          <img
            src={smartwatchIcon}
            alt='Devices'
            style={iconStyle}
            width='25'
          />
          <span className={`app-sidebar-label ${isCollapsed ? 'is-hidden' : ''}`}>Devices</span>
        </NavLink>

                {/* Connection Center (super-admin only) */}
        {user.super === true && (
        <NavLink
          className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}
          to='/connectionCenter'

          style={loggedIn ? { ...show, ...navLinkStyle } : hide}
          onMouseUp={() => this.setState({ isDevicesClicked: true })}
        >
          <i className='fa-brands fa-usb' style={iconStyle} />
          <span className={`app-sidebar-label ${isCollapsed ? 'is-hidden' : ''}`}>Connection Center</span>
        </NavLink>
        )}
              {/* Videos */}
        <NavLink
          className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}
          to='/video-tours'
          
          style={loggedIn ? { ...show, ...navLinkStyle } : hide}
          onMouseUp={() => this.setState({ isDevicesClicked: true })}
        >
          <i className='fa-regular fa-layer-group' style={iconStyle} />
          <span className={`app-sidebar-label ${isCollapsed ? 'is-hidden' : ''}`}>Resources</span>
        </NavLink>

        
        {/* Device Admin Link (visible only to super-admin) */}
        {user.super === true && (
          <NavLink
            className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}
            to='/deviceAdmin'
            
            style={loggedIn ? { ...show, ...navLinkStyle } : hide}
            onMouseUp={() => this.setState({ isDevicesClicked: true })}
          >
            <i className='fa-solid fa-toolbox' style={iconStyle} />
            <span className={`app-sidebar-label ${isCollapsed ? 'is-hidden' : ''}`}>Device Admin</span>
          </NavLink>
        )}

        {/* Report Diagnostics Link (visible only to super-admin) */}
        {user.super === true && (
          <NavLink
            className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}
            to='/report-diagnostics'
            
            style={loggedIn ? { ...show, ...navLinkStyle } : hide}
        >
          <i className='fa-solid fa-stethoscope' style={iconStyle} />
          <span className={`app-sidebar-label ${isCollapsed ? 'is-hidden' : ''}`}>Report Diagnostics</span>
        </NavLink>
        )}
      </div>
    )
  }
}

function SidebarWithRouter(props) {
  const location = useLocation();
  return <Sidebar {...props} location={location} />;
}

export default SidebarWithRouter
